import { render } from "./OverlayHeader.vue?vue&type=template&id=7ec7c846&scoped=true"
import script from "./OverlayHeader.vue?vue&type=script&lang=js"
export * from "./OverlayHeader.vue?vue&type=script&lang=js"

import "./OverlayHeader.vue?vue&type=style&index=0&id=7ec7c846&scoped=true&lang=css"

import exportComponent from "/Users/zellwegv/repos-work/fw-312-bird-identification-game/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ec7c846"]])

export default __exports__